/**
 *
 * @component 个人中心/我的方案/项目管理/项目详情/方案详情tab
 *
 **/
import React from 'react';
import ProjectCard from '&/components/ProjectSpace/ProjectCard';
import './SchemeDetailTab.scss';
import { Button } from 'antd';
import AddSchemeModal from './AddSchemeModal';

const SchemeDetailTab = props => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        props.renderFn(
            <Button type="primary" onClick={addScheme}>
                {intl.get('projectSpace.addScheme')}
            </Button>
        );
    }, []);

    function addScheme() {
        setVisible(true);
    }

    return (
        <div className="scheme-tab" id="parent">
            <div className="list-wrap">
                <ProjectCard single={true} />
            </div>
            <AddSchemeModal visible={visible} setVisible={setVisible} />
        </div>
    );
};

export default SchemeDetailTab;
